import { render, staticRenderFns } from "./ProductionQuota.vue?vue&type=template&id=4c053b1b&scoped=true&"
import script from "./ProductionQuota.vue?vue&type=script&lang=js&"
export * from "./ProductionQuota.vue?vue&type=script&lang=js&"
import style0 from "./ProductionQuota.vue?vue&type=style&index=0&id=4c053b1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c053b1b",
  null
  
)

export default component.exports